(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchevents/assets/javascripts/models/statmatchevents.js') >= 0) return;  svs.modules.push('/components/statistics/matchevents/assets/javascripts/models/statmatchevents.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  var log = new svs.core.log.Logger('svs.statistics.statMatchEvents');

  svs.statistics.models.statMatchEvents = Backbone.Model.extend({
    url: function() {
      return (
        svs.core.jupiter.url() +
        '/multifetch?urls=/sport/1/matches/' +
        this.urlParams.id +
        '/events|' +
        '/sport/1/matches/' +
        this.urlParams.id +
        '?include=match.externalIds.2,match.additionalInfos.description,match.additionalInfos.value,match.sport.id|' +
        '/sport/1/matches/' +
        this.urlParams.id +
        '/odds'
      );
    },
    defaults: {
      sport: 0,
      betRadarId: 0
    },
    initialize: function(options) {
      this.loader = new svs.components.Loader().show();
      var _self = this;
      this.urlParams = options.urlParams;
      this.socketResourcePath =
        '/sport/1/matches/' + this.urlParams.id + '/events';

      if (svs.core.detect.feature('ft-spelanalyser')) {
        svs.sport.gameAnalyzes.getGameAnalyzes({
          callback: function(err, gameAnalyzes) {
            if (err) {
              return;
            }

            _self.set('gameAnalyzes', gameAnalyzes);
          },
          matchId: this.urlParams.id
        });
      } else {
        this.parentId =
          options.parentId || 'svs-workarea-articles-gameanalyzestt';
        this.domainCategories = 'svs-domain-sport-events/' + this.urlParams.id;
        this.numOfArticles = options.numOfArticles || '1';

        var url = new svs.content.shared.ContentUrlBuilder('basicfilter')
          .addParams({
            parentId: this.parentId,
            domainCategories: this.domainCategories,
            count: this.numOfArticles
          })
          .build();

        svs.core.jupiter.get(url, function(response) {
          if (
            !response.error &&
            response.result &&
            response.result.length &&
            response.result[0].body
          ) {
            _self.set(
              'spelanalys',
              new Handlebars.SafeString(response.result[0].body)
            );
          }
        });
      }

      if (svs.utils.ns.isNamespace('statistics.data.matchModels.events', svs)) {
        if (svs.utils.ns.isNamespace('statistics.data.matchModels.info', svs)) {
          this.parse({
            responses: [
              svs.statistics.data.matchModels.events,
              svs.statistics.data.matchModels.info,
              svs.statistics.data.matchModels.odds
            ]
          });
        } else {
          this.parse(svs.statistics.data.matchModels.events);
        }
        _self.startPush(false);
        return this;
      }
      this.fetch({
        error: function() {
          _self.trigger('fetchError');
          _self.set('pending', false);
        }
      }).done(function() {
        _self.startPush(false);
      });
    },

    fetch: function(options) {
      this.set('pending', true);
      return Backbone.Model.prototype.fetch.call(this, options);
    },

    _getGroundTypeFromAdditionalInfos: function(additionalInfos) {
      if (!Array.isArray(additionalInfos)) {
        return undefined;
      }

      var length = additionalInfos.length,
        index = 0,
        info;

      for (; index < length; index++) {
        info = additionalInfos[index];
        if (
          info.description.toLowerCase() ===
          svs.statistics.constants.GROUND_TYPE
        ) {
          return info;
        }
      }

      return undefined;
    },

    parse: function(resp) {
      var response = resp,
        translate,
        groundType;
      if (_.isArray(resp.responses)) {
        response = resp.responses[0];
        if (svs.utils.ns.isNamespace('responses.1.match.externalIds.2', resp)) {
          response.betRadarId = resp.responses[1].match.externalIds[2];
        }
        if (
          svs.utils.ns.isNamespace('responses.1.match.additionalInfos', resp)
        ) {
          translate = new svs.sport.GroundTypeTranslate();
          groundType = this._getGroundTypeFromAdditionalInfos(
            resp.responses[1].match.additionalInfos
          );

          if (groundType) {
            response.groundType = translate.fromBetradarToKey(groundType.value);
          }
        }

        if (resp.responses[2].error === null) {
          this.oddsInfo = resp.responses[2].oddsInfo;
        }

        if (svs.utils.ns.isNamespace('responses.1.match.sport.id', resp)) {
          if (
            resp.responses[1].match.sport.id ===
            svs.statistics.constants.TROTTING
          ) {
            if (
              svs.statistics.data.overrideTrotting1X2Headers &&
              Object.prototype.hasOwnProperty.call(
                svs.statistics.data.overrideTrotting1X2Headers,
                response.events.matchId
              )
            ) {
              this.set(
                'overrideHeaders',
                svs.statistics.data.overrideTrotting1X2Headers[
                  response.events.matchId
                ]
              );
            } else if (
              Object.prototype.hasOwnProperty.call(
                svs.utils.url.queryString,
                'one'
              ) &&
              Object.prototype.hasOwnProperty.call(
                svs.utils.url.queryString,
                'x'
              ) &&
              Object.prototype.hasOwnProperty.call(
                svs.utils.url.queryString,
                'two'
              )
            ) {
              this.set('overrideHeaders', {
                one: svs.utils.url.queryString.one,
                x: svs.utils.url.queryString.x,
                two: svs.utils.url.queryString.two
              });
            } else {
              this.set('overrideHeaders', { one: '', x: '', two: '' });
            }
          }
        }
      }

      var statistics = response.statistics;
      var betStatisicsAvailible = false;

      if (statistics) {
        if (statistics.mutuals) {
          if (statistics.mutuals.history) {
            statistics.mutuals = [
              statistics.mutuals.history.homeWins,
              statistics.mutuals.history.draws,
              statistics.mutuals.history.awayWins
            ];
            response.statistics.mutuals = statistics.mutuals;
          }
        }
      }
      if ((response.events || {}).league) {
        if (
          this.get('drawNumber') &&
          this.get('drawNumber') ===
            svs.statistics.constants.SPECIAL_TROTTING_DRAW
        ) {
          response.events.league.sport = svs.statistics.constants.TROTTING;
        }
        this.set('sport', response.events.league.sport, { silent: true });
        if (svs.utils.ns.isNamespace('events.league.country', response)) {
          this.set('countryName', response.events.league.country.name, {
            silent: true
          });
        }
      }
      response = this.getTemplateFunction(
        'formatModelData',
        response,
        response
      );
      if (_.isObject(response) && _.isObject(response.events)) {
        if (response.events.distributions) {
          _.each(response.events.distributions, function(d) {
            d.productName =
              d.productName.substring(0, 1).toUpperCase() +
              d.productName.substring(
                1,
                d.productName.indexOf('tipset') > 0
                  ? d.productName.indexOf('tipset') + 6
                  : d.productName.length
              );
            d.formattedOddsOne = svs.themes.formatOdds(d.one);
            d.formattedOddsX = svs.themes.formatOdds(d.x);
            d.formattedOddsTwo = svs.themes.formatOdds(d.two);
          });
        }

        if (
          response.events.distributions ||
          response.events.newspaperPredictions ||
          response.events.odds
        ) {
          betStatisicsAvailible = true;
        }

        response.betStatisicsAvailible = betStatisicsAvailible;

        var ended = true;
        if (!this.theme) {
          this.initTheme();
        }
        if (this.theme) {
          this.theme.load(function(template, init) {
            if (init) {
              ended = init('isEnded', response);
            }
          }, 'init');
        }
        if (ended) {
        }

        response.isLive = this.getTemplateFunction(
          'isLive',
          response.events.status,
          response
        );
        response.hasStarted = this.getTemplateFunction(
          'hasStarted',
          response.events.status,
          response
        );
        response.hasPenalties = this.getTemplateFunction(
          'hasPenalties',
          response.events,
          response
        );
      }

      if (response) {
        response.formattedStartDate =
          this.getWeekDayFromResponse(response) +
          ', ' +
          this.getFormattedDateFromResponse(response, 'D/M, YYYY');
        response.formattedStartTime = this.getFormattedDateFromResponse(
          response,
          'HH:mm'
        );
      }

      this.set(response, { silent: true });
      this.trigger('change', this);
    },

    getWeekDayFromResponse: function(response) {
      var weekday = '';

      if (svs.utils.ns.isNamespace('events.startTime', response)) {
        weekday = moment(response.events.startTime).format('dddd');
      }

      return this.getCapitalized(weekday);
    },

    getCapitalized: function(string) {
      if (!string || !string.length) {
        return '';
      }

      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    getFormattedDateFromResponse: function(response, format) {
      var date = '';
      format = format || 'HH:mm, D/M, YYYY'; 

      if (svs.utils.ns.isNamespace('events.startTime', response)) {
        date = moment(response.events.startTime).format(format);
      }

      return date;
    },

    reverseSortAttr: function(response, attr) {
      var items = response;
      items = _.sortBy(items, function(item) {
        return parseInt(item[attr], 10);
      }).reverse();

      return items;
    },
    update: function(param) {
      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('MATCH_EVENTS', param.events);
      }

      if (_.isObject(param)) {
        this.set(this.parse(param));
      }
    },
    hasData: function() {
      return this.fetched;
    },
    getTemplateFunction: function(func, param, data) {
      var returner = false;
      if (!_.isObject(data.events)) {
        return returner;
      }
      if (!this.theme) {
        this.initTheme();
      }

      if (this.theme) {
        this.theme.load(function(template, init) {
          if (init) {
            returner = init(func, param);
          }
        }, 'init');
      }
      return returner;
    },
    startPush: function(getInitialData) {
      if (this.subscribed) {
        return;
      }

      if (window.location.href.indexOf('isMocked') > -1) {
        this.isMock = true;
      }

      if (_.isObject(this.get('events'))) {
        if (
          this.getStatusFunction('subscribeMatch', {
            time: this.get('events').startTime,
            status: this.get('events').status
          }) ||
          this.isMock
        ) {
          try {
            svs.core.socket.subscribe(
              this.socketResourcePath,
              this.update,
              this,
              getInitialData
            );
            this.subscribed = true;
          } catch (e) {
            log.error(
              'Socket subscribe error, path=' + this.socketResourcePath,
              e
            );
          }
        }
      }
      this.set('pending', false);
      this.loader.hide();
    },

    stopPush: function() {
      try {
        if (this.socketResourcePath && this.subscribed) {
          svs.core.socket.unsubscribe(this.socketResourcePath, this.update);
          this.subscribed = false;
        }
      } catch (e) {
        log.error(
          'Socket unsubscribe error, path=' + this.socketResourcePath,
          e
        );
      }
    },

    dispose: function() {
      this.stopPush();

      delete this.theme;
    },

    initTheme: function() {
      if (
        this.get('drawNumber') ===
        svs.statistics.constants.SPECIAL_TROTTING_DRAW
      ) {
        this.set('sport', {
          id: svs.statistics.constants.TROTTING,
          name: 'Trav',
          type: svs.statistics.constants.TYPE_TROTTING
        });
      }
      if (this.get('sport')) {
        var sport = this.get('sport');
        if (!this.theme) {
          this.theme = new svs.sport.themeLoader({
            sport: sport.id
          });
        }
      }
      if (!this.theme) {
        log.info('theme not found');
        this.clear({ silent: true });
      }
    },

    getStatusFunction: function(func, id) {
      var returner = false;

      if (!this.theme) {
        this.initTheme();
      }

      if (this.theme) {
        this.theme.load(function(template, init) {
          if (init) {
            returner = init(func, id);
          }
        }, 'init');
      }

      return returner;
    }
  });
})(Backbone, _, svs);

 })(window);